/**
 * @generated SignedSource<<8c17b75fb1b6ef5cfb6d5d3d4274af2c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { Semver } from "@/common/relayCustomScalar";
import { UsernameOrID } from "@/common/relayCustomScalar";
export type CloneWorkspaceVersionInput = {
  competitionId?: string | null | undefined;
  private?: boolean | null | undefined;
  slug?: string | null | undefined;
  version?: Semver | null | undefined;
};
export type WorkspaceVersionCloneButtonMutation$variables = {
  asEntity?: UsernameOrID | null | undefined;
  id: string;
  input: CloneWorkspaceVersionInput;
};
export type WorkspaceVersionCloneButtonMutation$data = {
  readonly cloneWorkspaceVersion: {
    readonly id: string;
    readonly version: Semver;
    readonly workspace: {
      readonly id: string;
      readonly slug: string;
    };
  };
};
export type WorkspaceVersionCloneButtonMutation = {
  response: WorkspaceVersionCloneButtonMutation$data;
  variables: WorkspaceVersionCloneButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "asEntity"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "asEntity",
        "variableName": "asEntity"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "WorkspaceVersion",
    "kind": "LinkedField",
    "name": "cloneWorkspaceVersion",
    "plural": false,
    "selections": [
      (v3/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceVersionCloneButtonMutation",
    "selections": (v4/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "WorkspaceVersionCloneButtonMutation",
    "selections": (v4/*:: as any*/)
  },
  "params": {
    "cacheID": "7861c297720556a4fb64b5e009d40d89",
    "id": null,
    "metadata": {},
    "name": "WorkspaceVersionCloneButtonMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceVersionCloneButtonMutation(\n  $id: ID!\n  $input: CloneWorkspaceVersionInput!\n  $asEntity: UsernameOrID\n) {\n  cloneWorkspaceVersion(id: $id, input: $input, asEntity: $asEntity) {\n    id\n    version\n    workspace {\n      id\n      slug\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "15fc4871f4e28e13a093cc58d692e6fd";

export default node;
